module.exports = __webpack_public_path__ + "img/mv--element--sp.ac72d152.png";